export default "__VITE_ASSET__sIQAqGCL__"